import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_Can = _resolveComponent("Can")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_FilterItem = _resolveComponent("FilterItem")!
  const _component_FilterContainer = _resolveComponent("FilterContainer")!
  const _component_DanhSachToaXeTable = _resolveComponent("DanhSachToaXeTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!

  return (_openBlock(), _createBlock(_component_PageContentSection, { "always-expanded": true }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.totalToaXeDisplay), 1)
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_Can, {
        all: [_ctx.DANH_MUC_TOA_XE.SUA]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ButtonCustom, {
            classes: `rounded-none m-0`,
            "button-type": _ctx.ButtonsType.ADD,
            "tooltip-message": "Thêm toa xe vào nhóm toa xe này",
            onClick: _ctx.openAddToaXeItemsModal
          }, null, 8, ["button-type", "onClick"])
        ]),
        _: 1
      }, 8, ["all"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_FilterContainer, null, {
        default: _withCtx(() => [
          _createVNode(_component_FilterItem, { label: "Tìm kiếm" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchTerm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                style: {"width":"20rem"},
                placeholder: "Tìm theo mã hoặc tên",
                onInput: _ctx.search
              }, null, 8, ["modelValue", "onInput"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DanhSachToaXeTable, {
        "cur-page": _ctx.currentPage,
        "delete-externally": true,
        items: _ctx.toaXeItems,
        "per-page": _ctx.perPage,
        "show-delete-toa-xe-button-in-modal": false,
        "show-delete-toa-xe-button-in-table": true,
        "show-dm-toa-xe": false,
        onOnDeleteButtonClicked: _cache[1] || (_cache[1] = 
          (payload) => _ctx.$emit('on-delete-button-clicked', payload)
        )
      }, null, 8, ["cur-page", "items", "per-page"]),
      (_ctx.toaXeItems.length)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            total: _ctx.totalItems,
            onChangePage: _cache[2] || (_cache[2] = (value) => (_ctx.currentPage = value)),
            onChangePageSize: _cache[3] || (_cache[3] = (value) => (_ctx.perPage = value))
          }, null, 8, ["page", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}